/**
 *
 * AdministratorBCFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';
import {
    ADMINISTRATOR_BC_ANNOUNCEMENT_FORM,
    ADMINISTRATOR_BC_ANNOUNCEMENT_FORM_DIALOG,
} from './constants';


export function AdministratorBCFormDialog({form, viewName}) {
    return (
        <AdvancedFormDialog
            name={ADMINISTRATOR_BC_ANNOUNCEMENT_FORM_DIALOG}
            formName={ADMINISTRATOR_BC_ANNOUNCEMENT_FORM}
            advancedForm={React.cloneElement(form, {viewName})}
            addModeTitle="Новое объявление"
            editModeTitle="Изменение объявления"
            viewModeTitle="Просмотр объявления"
            copyModeTitle="Копирование объявления"
        />
    );
}

AdministratorBCFormDialog.propTypes = {
    form: PropTypes.node.isRequired,
};

